module.exports = __webpack_public_path__ + "static/media/LV-CZT.81e813e6.jpg";